var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawPhotoViewerOpso(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 521.618,
    height: 720.834,
    viewBox: "0 0 521.618 720.834",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-699.192 -179.582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M885.366,883.334h-442.5a39.6,39.6,0,0,1-39.559-39.559V202.059A39.6,39.6,0,0,1,442.871,162.5H885.366a39.6,39.6,0,0,1,39.559,39.559V843.775a39.6,39.6,0,0,1-39.559,39.559Z",
    transform: "translate(295.885 17.082)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.7,851.03H434.651a12.208,12.208,0,0,1-12.194-12.194V192.869a12.208,12.208,0,0,1,12.194-12.194H878.7a12.208,12.208,0,0,1,12.2,12.194V838.836A12.208,12.208,0,0,1,878.7,851.03Z",
    transform: "translate(303.547 24.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.865,
    cy: 4.865,
    r: 4.865,
    transform: "translate(955.139 187.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.465 -82.051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M712.26,429.957H333.933a31.246,31.246,0,0,1-7.083-.9,31.624,31.624,0,0,1-24.236-30.843V269.623a31.762,31.762,0,0,1,31.741-31.712H712.26a31.329,31.329,0,0,1,14.627,3.58,30.4,30.4,0,0,1,5.072,3.31A31.39,31.39,0,0,1,744,269.623V398.216a31.776,31.776,0,0,1-31.741,31.741Z",
    transform: "translate(505.158 182.592)",
    fill: "#a0c300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.235,428.56Q721,365.936,749.523,304.55v69.385c-13.185,19.68-27.8,38.151-44.757,54.625Z",
    transform: "translate(496.825 181.176)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.015,247.124q-50.984,91.468-106.692,180.154h-6.466Q680.493,337.2,732.4,244.116a27.632,27.632,0,0,1,4.611,3.008Z",
    transform: "translate(498.34 182.46)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.207,315.2a1146.242,1146.242,0,0,1-73.4,113.58H370.258q37.87-46.135,75.795-92.27c7.253-8.856,15.125-18.133,26.005-21.732Z",
    transform: "translate(503.722 180.959)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.814,308.494c-4.02,4.189-7.872,8.547-11.5,13.073-7.984,9.615-15.856,19.314-23.756,28.985-4.92,6.016-9.84,12.033-14.7,18.049a35.909,35.909,0,0,1-4.386-3.318,39.334,39.334,0,1,1,50.273-60.508A36.255,36.255,0,0,1,430.814,308.494Z",
    transform: "translate(503.891 181.365)",
    fill: "#ff6884"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.492,335.375l-73.883-27.017-36.688-13.41c-11.948-4.358-23.869-9.334-36.211-12.483a57.087,57.087,0,0,0-32.781.422,75.368,75.368,0,0,0-25.555,15.856q-4.892,4.512-9.474,9.306c-4.02,4.189-7.872,8.547-11.5,13.073-7.984,9.615-15.856,19.314-23.756,28.985-4.92,6.016-9.84,12.033-14.7,18.049q-24.375,29.815-48.468,59.77a28.177,28.177,0,0,1-6.41-.815Q353.2,395.9,378.556,364.838c1.94-2.418,3.936-4.864,5.9-7.282q12.356-15.139,24.74-30.251c6.382-7.787,12.708-15.631,19.624-22.969.618-.675,1.237-1.321,1.884-2,14.029-14.507,31.544-27.327,52.517-27.664,12.342-.2,24.262,3.711,35.733,7.844,12.342,4.47,24.656,9.025,37,13.551l74.389,27.214,18.611,6.8C652.243,331.27,650.838,336.612,647.492,335.375Z",
    transform: "translate(504.618 181.81)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.5 -46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M560.216,546.695a19.8,19.8,0,1,1,19.8-19.8,19.8,19.8,0,0,1-19.8,19.8Z",
    transform: "translate(447.283 117.08)",
    fill: "#a0c300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.58,529.155l-5.612-8.192a1.664,1.664,0,1,0-2.746,1.881l3.63,5.3h-14.22a1.953,1.953,0,1,0,0,3.906h14.4l-3.808,5.558a1.664,1.664,0,1,0,2.746,1.881l5.612-8.192A2.2,2.2,0,0,0,574.58,529.155Z",
    transform: "translate(443.23 113.975)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(884.203 578.182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M560.217,546.7a19.8,19.8,0,1,0-19.8-19.8,19.8,19.8,0,0,0,19.8,19.8Z",
    transform: "translate(-540.42 -507.102)",
    fill: "#a0c300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.958,529.156l5.612-8.192a1.664,1.664,0,1,1,2.746,1.882l-3.63,5.3h14.22a1.953,1.953,0,1,1,0,3.906h-14.4l3.808,5.559a1.664,1.664,0,1,1-2.746,1.882l-5.612-8.192A2.2,2.2,0,0,1,553.958,529.156Z",
    transform: "translate(-544.473 -510.207)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 90,
    rx: 8,
    transform: "translate(739 665.461)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 90,
    rx: 8,
    transform: "translate(911 665.461)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19423,20205h-103a8.009,8.009,0,0,1-8-8v-74a8.011,8.011,0,0,1,8-8h103v90h0v0h0Z",
    transform: "translate(-18229 -19449.539)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 90,
    rx: 8,
    transform: "translate(739 767.461)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 90,
    rx: 8,
    transform: "translate(911 767.461)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19423,20205h-103a8.009,8.009,0,0,1-8-8v-74a8.011,8.011,0,0,1,8-8h103v90h0v0h0Z",
    transform: "translate(-18229 -19347.539)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.122,546.695a19.8,19.8,0,1,1,19.8-19.8,19.8,19.8,0,0,1-19.8,19.8Z",
    transform: "translate(552.674 71.08)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(201.102 -348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.122,546.695a19.8,19.8,0,1,1,19.8-19.8,19.8,19.8,0,0,1-19.8,19.8Z",
    transform: "translate(552.674 71.08)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.102 -348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.122,546.695a19.8,19.8,0,1,1,19.8-19.8,19.8,19.8,0,0,1-19.8,19.8Z",
    transform: "translate(552.674 71.08)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.102 -348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.122,546.695a19.8,19.8,0,1,1,19.8-19.8,19.8,19.8,0,0,1-19.8,19.8Z",
    transform: "translate(552.674 71.08)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 24,
    rx: 12,
    transform: "translate(739 237)",
    fill: "#a0c300"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawPhotoViewerOpso);
export default __webpack_public_path__ + "static/media/undraw_photo-viewer_opso.f361317e6d74eb3d1cc2c9b0d063aa4d.svg";
export { ForwardRef as ReactComponent };